module.exports = __webpack_public_path__ + "img/home_icon.50c3a0c4.svg";